var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#D0E0E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 19H15.25M12 9H16M14 10.5V9M10 14H18M16.5 17.5L17.25 19M11.5 17.5L10.75 19M12.25 15.75H12.255M15.75 15.75H15.755M12.4 17.5H15.6C16.4401 17.5 16.8601 17.5 17.181 17.3365C17.4632 17.1927 17.6927 16.9632 17.8365 16.681C18 16.3601 18 15.9401 18 15.1V12.9C18 12.0599 18 11.6399 17.8365 11.319C17.6927 11.0368 17.4632 10.8073 17.181 10.6635C16.8601 10.5 16.4401 10.5 15.6 10.5H12.4C11.5599 10.5 11.1399 10.5 10.819 10.6635C10.5368 10.8073 10.3073 11.0368 10.1635 11.319C10 11.6399 10 12.0599 10 12.9V15.1C10 15.9401 10 16.3601 10.1635 16.681C10.3073 16.9632 10.5368 17.1927 10.819 17.3365C11.1399 17.5 11.5599 17.5 12.4 17.5ZM12.5 15.75C12.5 15.8881 12.3881 16 12.25 16C12.1119 16 12 15.8881 12 15.75C12 15.6119 12.1119 15.5 12.25 15.5C12.3881 15.5 12.5 15.6119 12.5 15.75ZM16 15.75C16 15.8881 15.8881 16 15.75 16C15.6119 16 15.5 15.8881 15.5 15.75C15.5 15.6119 15.6119 15.5 15.75 15.5C15.8881 15.5 16 15.6119 16 15.75Z",
    stroke: "#45748C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRailIcon);
export default __webpack_public_path__ + "static/media/railIcon.c8c2ecc35002d5bd2be0809eb40fb2aa.svg";
export { ForwardRef as ReactComponent };